exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header{width:100%;height:70px;background:#000;overflow:hidden;position:fixed;z-index:13;top:0}.searchBox{width:83%;height:45%;margin:24px auto 0;background:#ccc}.txt{width:86%;background:#fff;box-sizing:border-box;padding-left:12px;outline:none;border:none;font-size:14px;font-family:\\\\5FAE\\8F6F\\96C5\\9ED1}.search,.txt{float:left;height:100%}.search{width:14%;background:#242424 url(" + require("../assets/images/search.png") + ") no-repeat 50%;background-size:40%}.search2{background:#242424 url(" + require("../assets/images/search2.png") + ") no-repeat 50%;background-size:40%;border-bottom:2px solid #7de87d;box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-e41742f0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header.vue
// module id = 57
// module chunks = 0